module.exports = __webpack_public_path__ + "static/img/A134.c036fbc9.jpg";